import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session8 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respRegles, setRespRegles] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour et bienvenue !</h3>
            <p>
              Lors de cette séance, nous continuons notre découverte du
              volontariat.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1sWy2YU0EIIRG8ZkOunW7FtQ0hJ2pqJjzupIXhozqjA0"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                L’association présentée dans la vidéo met à disposition des :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="velos"
                  control={<Radio />}
                  label="Vélos"
                />
                <FormControlLabel
                  value="chaussures"
                  control={<Radio />}
                  label="Chaussures"
                />
                <FormControlLabel
                  value="repas"
                  control={<Radio />}
                  label="Repas"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Lors de la dernière séance, tu as découvert – ou peut-être
              redécouvert – un jeu qui s’appelle Ouisticlic.
            </p>
            <p>
              Aujourd’hui, à toi d’expliquer les règles du jeu à un autre enfant
              ou membre de ta famille.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              A l’aide de tes notes de la dernière fois, écris les règles telles
              que tu les expliquerais à un autre enfant ou un membre de ta
              famille. Tu peux te faire aider par un adulte pour écrire
              ci-dessus si tu en as besoin.
            </p>
            <p>
              Tu peux te faire aider par un adulte pour écrire ci-dessus si tu
              en as besoin.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              id="regles"
              label="Règles"
              variant="outlined"
              value={respRegles}
              onChange={(e) => {
                setRespRegles(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors de la dernière séance, tu as pu visionner une vidéo dans
                laquelle des bénévoles expliquaient leur action. Tu as ensuite
                réfléchi à comment tu pourrais expliquer ton engagement
                bénévole.
              </p>
              <p>
                Aujourd’hui, c’est donc à toi de présenter le bénévolat et la
                cause de ton choix à un nouveau bénévole dans le groupe.
              </p>
              <p>Continuons !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                A l’aide de tes notes de la dernière fois, écris un petit texte
                qui résume tes idées pour présenter ton bénévolat et le thème
                choisi à un nouveau camarade bénévole. Tu peux te faire aider
                par un adulte pour écrire ci-dessus si tu en as besoin.
              </p>
              <p>
                Tu peux te faire aider par un adulte pour écrire ci-dessus si tu
                en as besoin.
              </p>
              <TextField
                multiline
                fullWidth
                rows="4"
                label="Règles"
                variant="outlined"
                value={respRegles}
                onChange={(e) => {
                  setRespRegles(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session8')
              .add({
                date: now,
                response: response,
                respRegles: respRegles,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session8;
